import React from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';
import { u3204FormatTokenCount } from '../utils/u3204ComputeConversationTokenUsage';
import U3204TokenTag from './U3204TokenTag';

interface U3204MessageTokenBadgeProps {
  count?: number;
  variant: 'input' | 'output';
}

const U3204MessageTokenBadge: React.FC<U3204MessageTokenBadgeProps> = ({ count, variant }) => {
  const { t, i18n } = useTranslation(NS);

  if (count == null) {
    return null;
  }

  const formattedCount = u3204FormatTokenCount(count, i18n.language);
  const labelKey = variant === 'input' ? 'tokens.input' : 'tokens.output';

  return (
    <span className="mt-1 self-end">
      <U3204TokenTag
        variant={variant}
        title={variant === 'input' ? (t as any)('tokens.inputTooltip', { ns: NS }) : undefined}
      >
        {(t as any)(labelKey, { ns: NS, count: formattedCount })}
      </U3204TokenTag>
    </span>
  );
};

export default U3204MessageTokenBadge;
